/**
 * <rotating-image-card>: crossfades through the .ric__img children on a timer.
 * Pauses on hover/focus and while off-screen; does nothing for a single image
 * or when the visitor prefers reduced motion (the first image just stays put).
 */
class RotatingImageCard extends HTMLElement {
  connectedCallback() {
    this.images = Array.from(this.querySelectorAll('.ric__img'));
    this.dots = Array.from(this.querySelectorAll('.ric__dot'));
    this.media = this.querySelector('.ric__media');
    this.dotsWrap = this.querySelector('.ric__dots');
    this.index = 0;
    this.interval = Math.max(1000, Number(this.dataset.interval) || 4000);

    if (this.images.length < 2) return;

    this.media?.classList.add('is-ready');
    this.dotsWrap?.classList.add('is-ready');
    this.#activate(0);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.addEventListener('mouseenter', this.stop);
    this.addEventListener('mouseleave', this.start);
    this.addEventListener('focusin', this.stop);
    this.addEventListener('focusout', this.start);

    this.observer = new IntersectionObserver(
      ([entry]) => (entry.isIntersecting ? this.start() : this.stop()),
      { threshold: 0.25 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.stop();
    this.observer?.disconnect();
  }

  start = () => {
    if (this.timer) return;
    this.timer = window.setInterval(() => this.next(), this.interval);
  };

  stop = () => {
    window.clearInterval(this.timer);
    this.timer = null;
  };

  next() {
    this.#activate((this.index + 1) % this.images.length);
  }

  #activate(i) {
    this.images[this.index]?.classList.remove('is-active');
    this.dots[this.index]?.classList.remove('is-active');
    this.index = i;
    this.images[i]?.classList.add('is-active');
    this.dots[i]?.classList.add('is-active');
  }
}

if (!customElements.get('rotating-image-card')) {
  customElements.define('rotating-image-card', RotatingImageCard);
}
